<template>
    <div class="text-center py-12 px-4">
        <div
            class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-primary-50 dark:bg-primary-900/20"
        >
            <component
                :is="icon || Inbox"
                class="h-6 w-6 text-primary-500"
                aria-hidden="true"
            />
        </div>
        <h3 class="mt-3 text-sm font-medium text-gray-900 dark:text-white">
            {{ title }}
        </h3>
        <p
            v-if="description"
            class="mt-1 text-sm text-gray-500 dark:text-gray-400 max-w-md mx-auto"
        >
            {{ description }}
        </p>
        <div v-if="$slots.default" class="mt-5">
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
import { Inbox } from "@lucide/vue";
import type { Component } from "vue";

interface Props {
    icon?: Component;
    title: string;
    description?: string;
}

defineProps<Props>();
</script>
